'use strict';
import get from 'lodash/get';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import {STATE_CHANGE_START} from 'redux-ui-router/lib/action-types';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import * as TASK_TYPE from '../../tasks/enums/TASK_TYPE';
import {buildListSupportEpicsNavHelper} from '../../core-utilities/redux';

/**
 * @typedef {Object} RequirementListSupportEpicsOptions
 * @property {ReduxObservableListActions} actions
 * @property {TASK_TYPE} taskType
 * @property {Function} getState
 * @property {String} viewName The ui-router state name for the list view
 * @property {bunyan} logger
 */

/**
 * @param {RequirementListSupportEpicsOptions} options
 */
export function buildListSupportEpics(options) {
  const actions = options.actions;
  const logger = options.logger;
  const updateListState = buildListSupportEpicsNavHelper(actions);

  return [
    onNavEpic,
  ];

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   * @return {Observable.<ReduxAction>}
   */
  function onNavEpic(action$, store) {
    return action$.ofType(STATE_CHANGE_START)
      .map(action => {
        if (get(action.payload, 'toState.name') === options.viewName) {
          const state = options.getState(store.getState());
          const parentId = get(action.payload, 'toParams.taskId');
          return state.init && state.parentId === parentId ? false : {
            prevParentId: state.parentId,
            nextParentId: parentId,
          };
        } else {
          return false;
        }
      })
      .filter(id => id !== false)
      .mergeMap(updateListState)
      .catch(epicErrorHandler(logger, 'onNavEpic'));
  }
}



// WEBPACK FOOTER //
// ./src/js/requirements/epics/listSupportEpics.js